export default "__VITE_ASSET__OnrV424H__"